export default __webpack_public_path__ + "static/media/ttg-dropdown.f8a4a9a3.webp";